<script setup lang="ts">
import { ref } from 'vue';

const emit = defineEmits<{
  'files-selected': [files: File[]];
}>();

const fileInput = ref<HTMLInputElement | null>(null);
const isDragging = ref(false);

function triggerFileInput() {
  fileInput.value?.click();
}

function handleFileSelect(event: Event) {
  const target = event.target as HTMLInputElement;
  if (target.files) {
    emit('files-selected', Array.from(target.files));
    target.value = '';
  }
}

function handleDrop(event: DragEvent) {
  isDragging.value = false;
  if (event.dataTransfer?.files) {
    emit('files-selected', Array.from(event.dataTransfer.files));
  }
}
</script>

<template>
  <div>
    <div
      class="flex h-16 cursor-pointer items-center justify-center rounded-md border border-dashed border-tint-80 bg-tint-20 transition-all hover:border-tint-100 hover:bg-tint-40"
      :class="{ 'bg-blue-50 border-highlight-500': isDragging }"
      @click="triggerFileInput"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="handleDrop"
    >
      <div class="flex items-center gap-2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="flex-shrink-0 text-shade-840"
        >
          <path
            d="M6.66667 13.3333L10 10M10 10L13.3333 13.3333M10 10V17.5M16.6667 13.9524C17.6846 13.1117 18.3333 11.8399 18.3333 10.4167C18.3333 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3975 5.73833 13.3051 5.58145C12.2183 3.73736 10.212 2.5 7.91667 2.5C4.46489 2.5 1.66667 5.29822 1.66667 8.75C1.66667 10.4718 2.36289 12.0309 3.48915 13.1613"
            stroke="currentColor"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="font-sans text-sm font-bold leading-[21px] text-shade-820">
          Drag and drop resumes here or click to browse
        </span>
      </div>
    </div>
    <input
      ref="fileInput"
      type="file"
      multiple
      accept=".pdf,.doc,.docx"
      class="hidden"
      @change="handleFileSelect"
    />
  </div>
</template>
